import React, { FC } from 'react'

interface FullscreenIconProps {
  className?: string
}

const FullscreenIcon: FC<FullscreenIconProps> = ({ className }) => (
  <svg
    width="36"
    height="37"
    className={className}
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.4"
      y="0.9"
      width="35.2"
      height="35.2"
      rx="17.6"
      fill="white"
    />
    <rect
      x="0.4"
      y="0.9"
      width="35.2"
      height="35.2"
      rx="17.6"
      stroke="#E5E5EA"
      strokeWidth="0.8"
    />
    <path
      d="M17 25.5C21.4183 25.5 25 21.9183 25 17.5C25 13.0817 21.4183 9.5 17 9.5C12.5817 9.5 9 13.0817 9 17.5C9 21.9183 12.5817 25.5 17 25.5Z"
      stroke="#343D48"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9984 27.4984L22.6484 23.1484"
      stroke="#343D48"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 14.5V20.5"
      stroke="#343D48"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 17.5H20"
      stroke="#343D48"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

)

export default FullscreenIcon
